<template>
  <div class="hbn-container" id="userInfo">
    <div class="search-form">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-form
            ref="form"
            :model="SelectUser"
            label-width="80px"
            label-position="top"
            size="mini"
          >
            <el-row :gutter="24">
              <el-col :span="6">
                <el-form-item label="员工姓名">
                  <el-input
                    id="UserName"
                    v-model="SelectUser.UserName"
                    placeholder="员工姓名"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="员工编号">
                  <el-input
                    id="CodeID"
                    v-model="SelectUser.userCode"
                    placeholder="员工编号"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col :span="6">
          <div style="padding-top: 28px">
            <el-button
              size="mini"
              class="hbn-button-serach"
              @click="SearchUserInfo"
              >查找</el-button
            >
            <span class="control-collapse" @click="show = !show">{{
              show ? "收起" : "展开"
            }}</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="hbn-table-screen">
      <div class="operation">
        <el-button
          class="custom-button"
          type="primary"
          @click="userEidt('', 0)"
        >
          <i class="el-icon-circle-plus-outline custom-icon"></i>
          <span>新增</span>
        </el-button>
        <el-button type="primary" class="custom-button" @click="importExcel">
          <i class="el-icon-upload custom-icon"></i>
          <span>导入</span>
        </el-button>
        <el-button type="primary" class="custom-button" @click="export2Excel">
          <i class="el-icon-download custom-icon"></i>
          <span>导出</span>
        </el-button>
      </div>
      <div class="custom-table-layer">
        <div style="margin-bottom: 13px">
          <vxe-table
            v-loading="demo.loading"
            :data="demo.UserListData"
            round
            border
            height="388"
            class="mytable-scrollbar"
            style="width: 100%"
            :highlight-current-row="true"
            @current-change="handleCurrentChange"
            @checkbox-change="handleSelectionChange"
            @checkbox-all="selectAllChangeEvent"
            ref="multipleTable"
            highlight-hover-row
            highlight-hover-column
            highlight-current-column
            show-overflow="tooltip"
            empty-text="没有更多数据了！"
            resizable
            stripe
          >
            <vxe-table-column
              fixed="left"
              type="checkbox"
              field="tableCheck"
              width="40"
            ></vxe-table-column>
            <vxe-table-column
              fixed="left"
              type="seq"
              width="55"
              title="序号"
              align="center"
            ></vxe-table-column>
            <template v-for="(item, key) in userList" :key="key">
              <vxe-table-column
                :field="item.prop"
                :title="item.label"
                :width="item.width"
                align="center"
                v-if="item.isShow"
                show-overflow-tooltip
                :sortable="item.order"
                :class-name="JSON.stringify(item)"
                :formatter="formatterData"
              />
            </template>

            <vxe-table-column
              width="150"
              fixed="right"
              title="操作"
              align="center"
            >
              <template #default="{ rowIndex }">
                <el-button
                  type="text"
                  size="small"
                  @click="userEidt(rowIndex, 1)"
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="userEidt(rowIndex, 2)"
                  >查看</el-button
                >
                <el-button 
                  size="small" 
                  type="text"
                  @click="userEidt(rowIndex, 3)"
                  >删除</el-button>
                <!-- <el-popconfirm
                  title="是否要删除?"
                  @confirm="userEidt(rowIndex, 3)"
                >
                  <template #reference>
                    <el-button size="small" type="text">删除</el-button>
                  </template>
                </el-popconfirm> -->
              </template>
            </vxe-table-column>
          </vxe-table>
        </div>
        <div class="pagination">
          <vxe-pager
            perfect
            size="mini"
            :current-page="PageQuery.pageindex"
            :page-size="PageQuery.PageSize"
            :page-sizes="[20, 50, 100, 500]"
            :total="total"
            :pager-count="5"
            :layouts="[
              'PrevJump',
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'NextJump',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @page-change="handlePageChange"
          >
            <template #left>
              <span class="page-left">
                <span>已选中 {{ checkendSum }}</span>
                <span class="clear" @click.prevent="clearRecords">清空</span>
              </span>
            </template>
          </vxe-pager>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <userEidt
      ref="Editdialog"
      v-model:dialogVisible="dialogVisible"
      @close-dialog="closeDialog"
      @handle-confirm="handleConfirm"
    ></userEidt>
    <excel
      importurl="/api/User/UploadFileAsync"
      fileName="用户.xlsx"
      :dialogVisible="UpLoaddialogVisible"
      @close-dialog="closeDialog"
      @error="error"
      @success="success"
    ></excel>
  </div>
</template>

<script>
import { Search } from "@element-plus/icons";
// import { userList } from "@assets/apiData/userList";
// import XEUtils from "xe-utils";
import { ElMessage, ElMessageBox } from "element-plus";
import userEidt from "@comp/UserInfo/userEidt.vue";
import { DeleteUser, GetUserInfo, selectByCodeID } from "@api/user";
import {
  defineComponent,
  ref,
  reactive,
  toRefs,
  computed,
  onMounted,
  watch,
  getCurrentInstance,
  watchEffect,
} from "vue";
import excel from "@comp/ExcelHelper/importExcel";
import Enumerable from "linq";
import { dateFormat } from "@/util/utils.js";
export default defineComponent({
  components: {
    userEidt,
    Search,
    excel,
  },

  setup(props, ctx) {
    let Editdialog = ref(null);
    const error = () => {
      init();
    };
    const success = () => {
      init();
    };

    const export2Excel = () => {
      require.ensure([], () => {
        const { export_json_to_excel } = require("@/excel/Export2Excel.js"); //必须使用绝对路径

        const tHeader = [
          ...Enumerable.from(userList)
            .select((item) => {
              return item.label;
            })
            .toArray(),
        ]; // 标题
        const filterVal = [
          ...Enumerable.from(userList)
            .select((item) => {
              return item.prop;
            })
            .toArray(),
        ]; // 导出的字段名
        let list = demo.UserListData;
        if (data.multipleSelection.length >= 1) {
          list = data.multipleSelection;
        }
        const exceldata = formatJson(filterVal, list);
        export_json_to_excel(tHeader, exceldata, `用户`);
      });
    };
    function formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    }

    const UpLoaddialogVisible = ref(false);
    let childData = reactive({});
    let PageQuery = reactive({
      pageIndex: 1,
      pageSize: 20,
      queryModel: {},
      orderbyCloums: "UserName",
    });
    let total = ref(50);
    let data = reactive({
      multipleSelection: [],
    });
    let demo = reactive({
      loading: false,
      UserListData: [],
    });
    let dialogVisible = ref(false);
    let optionsState = reactive([
      {
        value: "",
        label: "全部",
      },
      {
        value: "0",
        label: "启用",
      },
      {
        value: "1",
        label: "禁用",
      },
    ]);
    let show = ref(false);
    let optionsYGXZ = reactive([
      {
        value: "",
        label: "全部",
      },
      {
        value: "1",
        label: "管理员",
      },
      {
        value: "2",
        label: "普通用户",
      },
    ]);
    let SelectUser = reactive({
      UserName: "",
      userCode: "",
    });
    const importExcel = () => {
      UpLoaddialogVisible.value = true;
    };

    function userEidt(index, type) {
      const params = {
        userId: "",
      };
      switch (type) {
        //新增
        case 0:
          Editdialog.value.initDialog("insert");
          dialogVisible.value = true;
          break;
        //修改
        case 1:
          params.userId = demo.UserListData[index].id;
          selectByCodeID(params)
            .then((resultData) => {
              Editdialog.value.initDialog("update", resultData);
              dialogVisible.value = true;
            })
            .catch(({ code, message }) => {
              console.log(message);
              ElMessage.error(message);
            });
          break;
        //查看
        case 2:
          params.userId = demo.UserListData[index].id;
          selectByCodeID(params)
            .then((resultData) => {
              Editdialog.value.initDialog("view", resultData);
              dialogVisible.value = true;
            })
            .catch((code, message) => {
              ElMessage.error(message);
            });
          break;
        //删除
        case 3:
          //1.提示是否删除
          //2.删除
          ElMessageBox.confirm(
            `是否要删除?`,
            "提示",
            {
              cancelButtonClass: "cancelstyle",
              confirmButtonClass: "confirmstyle",
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
              closeOnClickModal: false,
            }
          )
            .then(() => {
              params.userId = demo.UserListData[index].id;
              DeleteUser(params)
                .then((res) => init())
                .catch((message) => {
                  ElMessage.error(message);
                });
            })
            .catch(() => {
              return;
            });
          break;
      }
    }
    //弹出框事件
    function closeDialog(val) {
      if (!val) {
        dialogVisible.value = false;
      } else {
        UpLoaddialogVisible.value = false;
      }
    }
    function handleConfirm(val) {
      console.log("子组件传过来的值：", val);
      childData = val;
      init();
    }

    function handlePageChange({ currentPage, pageSize }) {
      if (PageQuery.PageSize != pageSize) {
        PageQuery.pageindex = 1; //说明更改了每页展示条数，要从第一页进行展示
        PageQuery.PageSize = pageSize;
      } else {
        PageQuery.pageindex = currentPage;
      }
      init();
    }
    const handleCurrentChange = ({ row }) => {
      console.log(`current page: ${row}`);
      console.log(PageQuery);
    };
    //全不选
    const toggleSelection = (rows) => {
      if (rows) {
        rows.forEach((row) => {
          //this.$refs.multipleTable.toggleRowSelection(row)
        });
      } else {
        //this.$refs.multipleTable.clearSelection()
      }
    };

    const multipleTable = ref(null);
    let checkendSum = ref(0);
    //选中数量
    const selectAllChangeEvent = ({ checked, records }) => {
      data.multipleSelection = records;
      checkendSum.value = records.length;
    };
    const handleSelectionChange = ({ records }) => {
      data.multipleSelection = records;
      checkendSum.value = records.length;
    };
    const clearRecords = () => {
      multipleTable.value.clearCheckboxRow();
      checkendSum.value = 0;
    };
    //查找
    function SearchUserInfo() {
      let queryModel = {
        userName: SelectUser.UserName,
        userCode: SelectUser.userCode,
      };
      PageQuery.queryModel = queryModel;
      console.log(JSON.stringify(PageQuery));
      init();
    }
    function init() {
      demo.loading = true;
      GetUserInfo(JSON.stringify(PageQuery))
        .then(({ entities, totalCount }) => {
          demo.UserListData = ref(entities);
          total = ref(totalCount);
          console.log(demo.UserListData);
          demo.loading = false;
        })
        .catch((error) => {
          demo.loading = false;
          console.log("用户查询失败", error);
        });
    }
    const formatterData = ({ cellValue, row, column }) => {
      let head = JSON.parse(column.className);
      let format = head.format;
      switch (format) {
        case "datetime":
          cellValue = dateFormat("YYYY-mm-dd HH:MM:SS",cellValue);
          break;
        case "checkbox":
          cellValue = cellValue == "1" ? "是" : "否";
          break;
        case "dropdown":
          cellValue = cellValue == "1" ? "管理员" : "普通用户";
          break;
        case "registerType":
          cellValue = cellValue == "0" ? "平台注册" : "小程序注册";
          break;
      }
      return cellValue;
    };
    //页面初始化
    onMounted(() => {
      init();
    });

    return {
      Editdialog,
      export2Excel,
      ...toRefs(data),
      UpLoaddialogVisible,
      importExcel,
      SearchUserInfo,
      init,
      checkendSum,
      toggleSelection,
      handleCurrentChange,
      userEidt,
      closeDialog,
      handleConfirm,
      demo,
      show,
      SelectUser,
      optionsYGXZ,
      optionsState,
      dialogVisible,
      total,
      PageQuery,
      userList,
      childData,
      handlePageChange,
      success,
      error,
      selectAllChangeEvent,
      handleSelectionChange,
      clearRecords,
      multipleTable,
      formatterData,
    };
  },
});
</script>

<style lang="scss" scoped>
@import "@/common/css/Hbn_modules/reset-input";

.custom-table-header > th {
  background: #dfdfdf !important;
}

.custom-table-header > th > .cell {
  font-family: Alibaba PuHuiTi-Medium, Alibaba PuHuiTi;
  font-weight: 500;
  color: #868686 !important;
  line-height: 22px;
}

.custom-table-layer ::v-deep .el-table .cell {
  color: #32383d;
}

.el-table .cell {
  color: #32383d;
}

.el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
  display: none;
}

.custom-table-layer .el-pagination.is-background .btn-prev,
.custom-table-layer .el-pagination.is-background .btn-next,
.custom-table-layer .el-pagination.is-background .el-pager li {
  border: 1px solid #acb5bd;
  width: 32px;
  height: 32px;
  line-height: 32px;
  background-color: #fff;
}

/*滚动条整体部分*/
.mytable-scrollbar ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/*滚动条的轨道*/
.mytable-scrollbar ::-webkit-scrollbar-track {
  background-color: #ffffff;
}

/*滚动条里面的小方块，能向上向下移动*/
.mytable-scrollbar ::-webkit-scrollbar-thumb {
  background-color: #bfbfbf;
  border-radius: 5px;
  border: 1px solid #f1f1f1;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:hover {
  background-color: #a8a8a8;
}

.mytable-scrollbar ::-webkit-scrollbar-thumb:active {
  background-color: #787878;
}

/*边角，即两个滚动条的交汇处*/
.mytable-scrollbar ::-webkit-scrollbar-corner {
  background-color: #ffffff;
}

.page-left {
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
}

.operation {
  display: flex;
}

.pagination {
  margin: 0;
  width: 100%;
  /* position: absolute;
        bottom: 0; */
  background-color: #fff;
  z-index: 7;
  padding: 5px 0;
}
</style><style lang="scss" scoped>
@import "@/common/css/Hbn_modules/hbn-base-model";

#userInfo {
}
</style>
<style scoped>
</style>
